module.exports = __webpack_public_path__ + "img/Billing.e9f266a2.svg";